import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaArrowRight,
  FaBolt,
  FaBookOpen,
  FaBrain,
  FaCertificate,
  FaChartLine,
  FaFileSignature,
  FaGlobe,
  FaProjectDiagram,
} from 'react-icons/fa';
import './UniversityPromotion.css';
import { useAuth } from '../../context/AuthContext';

const UniversityPromotion = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();

  const handleUniversityClick = () => {
    navigate(isLoggedIn ? '/university/dashboard' : '/login');
  };

  return (
    <section className="university-promotion">
      <div className="university-promotion-container">
        <div className="university-promotion-grid">
          <div className="university-promotion-left">
            <p className="university-eyebrow">ULSAAPP University</p>
            <h2 className="university-promotion-title">Build Your Desired Degree. Get Certified by AI Powered Virtual University.</h2>
            <p className="university-promotion-subtitle">
              Choose any subjects, learn from anywhere, and validate your knowledge through
              AI-generated exams and instant evaluation.
            </p>
            <button className="university-home-btn" onClick={handleUniversityClick}>
              Enter ULSAAPP University
              <FaArrowRight />
            </button>
          </div>

          <div className="university-promotion-right">
            <div className="university-features">
              <div className="university-feature">
                <div className="university-feature-icon-wrap">
                  <FaProjectDiagram className="university-feature-icon" />
                </div>
                <h3>Multi-Subject Flexibility</h3>
                <p>Combine subjects across disciplines without restrictions or predefined paths</p>
              </div>

              <div className="university-feature">
                <div className="university-feature-icon-wrap">
                  <FaGlobe className="university-feature-icon" />
                </div>
                <h3>Learn from Any Source</h3>
                <p>Study from YouTube, external platforms, or our Academy-no limitations</p>
              </div>

              <div className="university-feature">
                <div className="university-feature-icon-wrap">
                  <FaBookOpen className="university-feature-icon" />
                </div>
                <h3>Integrated Learning Access</h3>
                <p>Seamlessly switch to Academy courses when preparing for exams</p>
              </div>

              <div className="university-feature">
                <div className="university-feature-icon-wrap">
                  <FaFileSignature className="university-feature-icon" />
                </div>
                <h3>AI-Generated Examinations</h3>
                <p>Dynamic exams created in real-time based on selected subjects and exam levels (Diploma, Graduation, Post Graduation)</p>
              </div>

              <div className="university-feature">
                <div className="university-feature-icon-wrap">
                  <FaBolt className="university-feature-icon" />
                </div>
                <h3>Instant AI Evaluation</h3>
                <p>Get detailed scoring, analysis, and improvement insights instantly</p>
              </div>

              <div className="university-feature">
                <div className="university-feature-icon-wrap">
                  <FaCertificate className="university-feature-icon" />
                </div>
                <h3>Certification on Demand</h3>
                <p>Take exams anytime and earn certifications without waiting cycles</p>
              </div>

              <div className="university-feature">
                <div className="university-feature-icon-wrap">
                  <FaBrain className="university-feature-icon" />
                </div>
                <h3>Real Skill Validation</h3>
                <p>Exams focus on practical understanding, not memorization</p>
              </div>

              <div className="university-feature">
                <div className="university-feature-icon-wrap">
                  <FaChartLine className="university-feature-icon" />
                </div>
                <h3>Performance Tracking</h3>
                <p>Track past exams, scores, and improvement over time</p>
              </div>



            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UniversityPromotion;
